import { render } from "./StockProducto.vue?vue&type=template&id=21c56314"
import script from "./StockProducto.vue?vue&type=script&lang=js"
export * from "./StockProducto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__